import React, {useEffect, useMemo, useState} from 'react'
import {conversibilidadeFields, mapConversibilidadeToTable} from "./conversabilidade-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import {useLocation} from "react-router-dom"
import MotorConversibilidadeService from "../../../../../../../services/motor-conversibilidade-service"

const ConversabilidadeTable = (
    {
        setLoading,
        idCaracteristica,
        conversibilidadePublicado,
        tableData,
        setTableData,
        clearTable
    }) => {

    const service = useMemo(() => new MotorConversibilidadeService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        if (!idCaracteristica) return
        const {origem} = navigationState
        if (origem === "ver") {
            loadConversibilidade()
        }
    }, [idCaracteristica])

    useEffect(() => {
        const {origem} = navigationState
        if (origem === "duplicar") {
            const {Data} = navigationState
            const {Conversibilidade} = Data

            if (Conversibilidade !== null) {
                setTableData(mapConversibilidadeToTable(Conversibilidade))
            }
        }
    }, [])

    const loadConversibilidade = () => {
        setLoading(true)

        service.getConversibilidade(idCaracteristica)
            .then(response => {
                const {body} = response

                if (body && body.length > 0) {
                    conversibilidadePublicado(true)
                    const formatted = mapConversibilidadeToTable(body)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadConversibilidadeTemporario()
                }
            })
            .catch(error => console.error("Erro getConversibilidade:", error))
            .finally(() => setLoading(false))
    }

    const loadConversibilidadeTemporario = () => {
        setLoading(true)

        service.getTemporarioConversibilidade(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body || response?.data

                if (bodyTemp) {
                    // Extrair array de Premio do objeto temporário
                    const conversibilidades = Array.isArray(bodyTemp)
                        ? bodyTemp
                        : bodyTemp?.Conversibilidades || []

                    const formatted = mapConversibilidadeToTable(conversibilidades)

                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    console.warn("Nenhum dado temporário encontrado")
                }
            })
            .catch(error => console.error("Erro getTemporarioConversibilidade:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, conversibilidadeFields)}
                pasteData={async () => await pasteTableFromClipboard(conversibilidadeFields, setTableData)}
                clearTable={() => clearTable(setTableData)}
                fields={conversibilidadeFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

ConversabilidadeTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    conversibilidadePublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default ConversabilidadeTable